import { createAction, props } from '@ngrx/store';
import { CategoryEntity } from './categories.models';

export const initCategories = createAction(
  '[Filter Results Page] Init Categories',
  props<{ id?: number; language?: string }>()
);
export const categoryPageOpened = createAction(
  '[Category Page] Page opened',
  props<{ id?: number; language?: string }>()
);
export const updateId = createAction('[Filter Results Page] Update category ID', props<{ id: number | undefined }>());

export const loadCategoriesSuccess = createAction(
  '[Categories/Api] Get Categories Success',
  props<{ categories: CategoryEntity[] }>()
);

export const loadCategoriesFailure = createAction('[Categories/Api] Get Categories Failure', props<{ error: any }>());
